<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>계약</li>
        <li>미납조회</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>미납조회</h2>
        <div class="depLink">
          <button type="button" title="메뉴"><span>미납조회</span></button>
          <ul>
            <li>
              <router-link to="/contactpoint"
                ><span>알아두실 사항</span></router-link
              >
            </li>
            <li>
              <router-link to="/sbcpInpInqNdPolOtpt"
                ><span>청약입력/조회 및 증권출력</span></router-link
              >
            </li>
            <li>
              <router-link to="/subsChangeForm"
                ><span>증권 간략 정정</span></router-link
              >
            </li>
            <li>
              <router-link to="/staMon"><span>계약통계</span></router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="sortWrap type2">
          <dl>
            <dt class="w72">기간지정</dt>
            <dd>
              <div class="split">
                <div class="form_input_area type_calendar" style="width: 47%">
                  <datepicker
                    v-model="state.dateInfo.inpStDt"
                    :locale="ko"
                    class="form_input"
                    inputFormat="yyyy-MM-dd"
                    typeable
                    ref="startDate"
                    @input="inputDate"
                    maxlength="10"
                  />
                  <button type="button" class="btn_calendar" @click="openCalendar('startDate')" @blur="closeCalendar('startDate')">
                    <span>날짜선택</span>
                  </button>
                </div>

                <span style="margin: 13px 0px 0px 10px">~</span>

                <div class="form_input_area type_calendar" style="width: 46%">
                  <datepicker
                    v-model="state.dateInfo.inpEdDt"
                    :locale="ko"
                    class="form_input"
                    typeable
                    ref="endDate"
                    @input="inputDate"
                    maxlength="10"
                  />
                  <button type="button" class="btn_calendar" @click="openCalendar('endDate')" @blur="closeCalendar('endDate')">
                    <span>날짜선택</span>
                  </button>
                </div>
                <div class="inpSlt">
                  <button type="button" class="sltBtn" title="조건 선택">
                    <span>전체</span>
                  </button>
                  <ul>
                    <li>
                      <button type="button" class="sltOpt" title="선택">
                        <span>전체</span>
                      </button>
                    </li>
                    <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                    <li>
                      <button type="button" class="sltOpt">
                        <span>{{ logId }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
            </dd>
          </dl>
          <button type="button" class="btnSearch" @click="fnSearch(true)">
            <span class="hide">검색</span>
          </button>
        </div>

        <h3 class="conTit">계약사항</h3>
        <div class="searchInfo">
          <div class="typeSplit1">
            <dl>
              <dt>미수건수</dt>
              <dd v-if="searchResult.length == 0">0건</dd>
              <dd v-if="searchResult.length != 0">{{ unpayLength }}건</dd>
            </dl>
            <dl>
              <dt>미수보험료</dt>
              <dd v-if="searchResult.length == 0">0원</dd>
              <dd v-if="searchResult.length != 0">
                {{ util.addCommas(totalrRptPrem + "") }}원
              </dd>
            </dl>
            <dl>
              <dt>계약자</dt>
              <dd>{{ n_ctorkr }}</dd>
            </dl>
          </div>
        </div>

        <div class="tabStyle2">
          <table>
            <caption>
              조회결과
            </caption>
            <colgroup>
              <col width="160" />
              <col width="90" />
              <col width="220" />
              <col width="140" />
              <col width="140" />
              <col width="160" />
              <col width="150" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" height="62">증권번호</th>
                <th scope="col">배서</th>
                <th scope="col">Ref NO.</th>
                <th scope="col">계상일</th>
                <th scope="col">보험료(￦)</th>
                <th scope="col">출력</th>
                <th scope="col">입력자</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, index) in searchResult" :key="index">
                <td height="74">{{ d.polNo }}</td>
                <td>{{ d.endrNo }}</td>
                <td>{{ d.refnNo }}</td>
                <td>{{ d.endrHisStdNo.substring(0, 8) }}</td>
                <td>{{ util.addCommas(d.rcptPrem) }}</td>
                <td>
                  <button
                    type="button"
                    class="btnType colorBlL sizeXS"
                    @click="fnPolPrint(d, index)"
                  >
                    <span>증권</span>
                  </button>
                  <button
                    v-if="d.endrNo > 0"
                    type="button"
                    class="btnType colorYL sizeXS"
                    @click="fnEndrPrint(d, index)"
                  >
                    <span>배서</span>
                  </button>
                </td>
                <td>-</td>
              </tr>
              <tr v-if="searchResult.length == 0">
                <td colspan="10">
                  <p class="noData">조회된 결과가 없습니다.</p>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 더보기 없을떄 삭제 영역 [s] -->
          <button
            type="button"
            class="btnMore"
            v-if="isActiveBtnMore()"
            @click="fnSearch()"
          >
            <span>더보기</span>
          </button>
          <!-- 더보기 없을떄 삭제 영역 [e] -->
        </div>
      </div>
    </div>
  </div>
  <FnPolPrint ref="fnPolPrintRef" @close="handlePopupClose"></FnPolPrint>
  <FnEndrPrint ref="fnEndrPrintRef" @close="handlePopupClose"></FnEndrPrint>
</template>

<script setup>
// @ is an alias to /src

import {
  ref,
  reactive,
  computed,
  inject,
  onMounted,
  onBeforeMount,
  onBeforeUpdate,
} from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import _ from "lodash";
import Datepicker from "vue3-datepicker";

import FnPolPrint from "@/components/common/layerPop/FnPolPrint.vue";
import FnEndrPrint from "@/components/common/layerPop/FnEndrPrint.vue";

const axios = inject("axios");
let logId = ref(null);
let n_ctorkr = ref(null);
let cusNo = ref(null);
let unpayLength = ref(null);
let totalrRptPrem = ref(0);

let searchResult = ref([]);

const fnPolPrintRef = ref(null);
const fnEndrPrintRef = ref(null);

let startDate = ref(null);
let endDate = ref(null);


const swalAlert = inject("swalAlert");

let pageNum = ref(1);
let now = new Date();


const openCalendar = (tp) => {
  switch(tp) {
    case "startDate":
      startDate.value.renderView('day')
      break;
    case "endDate":
      endDate.value.renderView('day')
      break;
  }
  
}

const closeCalendar = (tp) => {
  switch(tp) {
    case "startDate":
      startDate.value.renderView('none')
      break;
    case "endDate":
      endDate.value.renderView('none')
      break;
  }
}

//진입시 검색 기간 1달
const state = reactive({
  currDateFormatEd: util.formatDate(new Date(), "yyyy-mm-dd"),
  currDateFormatSt: util.formatDate(
    new Date(now.setDate(now.getDate() - 31)),
    "yyyy-mm-dd"
  ),
  dateInfo: {},
});


//더보기
const isActiveBtnMore = () => {
  return (
    searchResult.value.length != 0 &&
    unpayLength.value >= 31 &&
    unpayLength.value / 30 > pageNum.value
  );
};



//페이지 진입시
onMounted(async () => {
  await load();
  console.log("로그인 정보값", sessionUserInfo);
  logId.value = sessionUserInfo.logId;
  n_ctorkr.value = sessionUserInfo.userInfo.n_ctorkr;
  cusNo.value = sessionUserInfo.slzCusInf.cusNo;
  state.dateInfo.inpStDt = new Date(state.currDateFormatSt);
  state.dateInfo.inpEdDt = new Date(state.currDateFormatEd);
  fnSearch(true);
  axios.json('/logHisLdg.do', {memo:"미납조회" ,page:window.location.hash});
});

//증권 출력
const fnPolPrint = async (d) => {
  //증권 출력시 보내줘야하는 데이터
  let param = {
    polNo: d.polNo,
    endrHisStdNo: d.endrHisStdNo,
    endrNo: d.endrNo,
    ctrId: d.ctrId,
    pdCd: "",
  };
  //FNGCTGFO0137
  let Result = await axios.transaction("FNGCTGFO0137", param);

  if (Result.msg.standCd != "FNGCT200549") {
    Result.body.ctrId = d.ctrId;
    Result.body.endrHisStdNo = d.endrHisStdNo;

    fnPolPrintRef.value.open(Result);
  } else {
    swalAlert(
      "미수증권으로 출력이 제어됩니다. 30일 이상 된 미수내역을 확인 바랍니다."
    );
    return;
  }
};

//배서 출력
const fnEndrPrint = async (d) => {
  //배서 출력시 보내줘야 하는 데이터
  let param = {
    polNo: d.polNo,
    endrHisStdNo: d.endrHisStdNo,
    endrNo: d.endrNo,
    ctrId: d.ctrId,
    pdCd: "",
  };
  console.log(param);
  let Result = await axios.transaction("FNGCTGFO0108", param);

  Result.body.ctrId = d.ctrId;
  Result.body.endrHisStdNo = d.endrHisStdNo;
  Result.body.otptSh = d.otptSh;

  console.log(Result);

  fnEndrPrintRef.value.open(Result);
};

//조회
const fnSearch = async (reset) => {
  if (reset) {
    searchResult.value = [];
    totalrRptPrem.value = 0;
    pageNum.value = 1;
  } else pageNum.value = pageNum.value + 1;

  //조회 기간 확인
  if (
    util.formatDate(state.dateInfo.inpStDt, "yyyymmdd") >
    util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd")
  ) {
    swalAlert("조회기간을 확인해 주세요.");
    return;
  } else if (
    util.getDay(
      util.formatDate(state.dateInfo.inpStDt, "yyyymmdd"),
      util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd")
    ) > 31
  ) {
    swalAlert("검색기간은 31일 까지 가능합니다.");
    return;
  }

  //데이터
  let param = {
    inpStDt: util.formatDate(state.dateInfo.inpStDt, "yyyymmdd"),
    inpEdDt: util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd"),
    // inetUsrId: logId.value,
    inqDiv: "1",
    polNo: "",
    cusNo: cusNo.value, //10001724245,10001326596
    scrnDiv: "2",
    pstmPg: pageNum.value + "",
  };
  let Result = await axios.transaction("FNGCTNFO0195", param);
  
  if (_.isEmpty(Result.body?.cargInetCtrLstDtlInfBcVo)) return;
  if (Result.msg.standCd != "FNGCM000005") {
    searchResult.value = searchResult.value.concat(
      _.flatten([Result.body?.cargInetCtrLstDtlInfBcVo || Result.body])
    );
  }
  unpayLength.value = Result.body.unclCnt;
  totalrRptPrem.value = Result.body.unclPrem;
};
</script>

<style></style>
